const HedgingHistoricalWindowEnum = {
  All   : 'All',
  Window: 'Window'
}

export default HedgingHistoricalWindowEnum
